import React from "react";
import DatePickerField from "controls/global/datepicker";
import { isValidDate } from "pages/file/utils/helper";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";
import { isPastDate } from "utils/shared";
import { showToast } from "controls/global/stewart-toast/showToast";

const PAST_DATE_WARNING_MESSAGE = "The Anticipated Closing Date entered is in the past.";

type Props = {
  name: string;
  defaultValue?: any;
  disabled?: boolean;
  onChange?: (date: Date | null) => void;
  // forceRerender: boolean;
};

export default function AnticipatedClosingDateField ({
  name,
  defaultValue,
  disabled,
  onChange,
  // forceRerender,
}: Props) {

  const {setValue} =  useFormWrapper();

  const clearDate = () => {
      setTimeout(() => {
        setValue(name, undefined);  
      }, 100);    
  }

  const onChangeCallback = (date: Date | null) => {
    // if (!isValidDate(date)) {
    //   clearDate();
    // }
    onChange && onChange(date);
  };

  const onBlurCallback = (date: Date | null) => {
    if (isValidDate(date)) {
      if (isPastDate(date!)) {
        showToast({
          type: 'warning',
          title: 'Warning!',
          message: PAST_DATE_WARNING_MESSAGE
        });
      }
    }
    else {
      clearDate();
    }
  }  

  return (
    <>
      <DatePickerField
        label="Anticipated Closing Date"
        // minDate={new Date()}
        showError={true}
        validateOnBlur={false}
        {...{
          disabled,
          name,
          defaultValue,
          onChangeCallback: onChangeCallback,
          onBlurCallback: onBlurCallback,
        }}
      />
    </>
  );
}
